import type { auth as en } from '@/i18n/locales/en/auth';
import type { Translation } from '@/i18n/types';

export const auth: Translation<typeof en> = {
  signInFailed: 'Η σύνδεση απέτυχε',
  checkingSession: 'Έλεγχος της σύνδεσής σας…',
  redirectingToSignIn: 'Ανακατεύθυνση στη σύνδεση…',
  signingIn: 'Σύνδεση σε εξέλιξη…',
  backToDashboard: 'Επιστροφή στον πίνακα ελέγχου',
};
